import { Component, OnInit, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core';
import { contextMenuTypes } from '../../../constants/context-menu-types.enum';

@Component({
  selector: 'gen-generic-context-menu',
  templateUrl: 'generic-context-menu.component.html',
  styleUrls: ['generic-context-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class GenericContextMenuComponent implements OnInit {
  @Input() active: boolean = false;
  @Input() value: any;
  @Input() type: contextMenuTypes;
  @Input() coordinates: { x: number, y: number};
  @Input() arrowPXOffset: number = 10;
  @Output() update: EventEmitter<any> = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }

  getEnum(type) {
    return contextMenuTypes[type.toUpperCase()] || null;
  }

  updateEmit($event) {
    if ($event.event) {
      $event.event.stopPropagation();
      $event.event.preventDefault();
      delete $event.event;
    }
    this.update.emit($event);
  }

}
